import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import { withStyles } from '@material-ui/core/styles';
import { Checkbox } from '@material-ui/core';
export const OutlinedCheckbox = withStyles({
    root: {
        color: 'var(--primary-color)',
        '&$checked': {
            color: 'var(--primary-color)',
        },
    },
    checked: {},
})((props) => (
    <Checkbox
        {...props}
        icon={
            <span
                style={{
                    width: 18,
                    height: 18,
                    border: '2px solid var(--primary-color)',
                    borderRadius: 4,
                }}
            />
        }
        checkedIcon={
            <span
                style={{
                    width: 18,
                    height: 18,
                    border: '2px solid var(--primary-color)',
                    borderRadius: 4,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'transparent',
                }}
            >
                <CheckIcon style={{ fontSize: 16, color: 'var(--primary-color)' }} />
            </span>
        }
    />
));
